import React from 'react'
import styled from 'styled-components'
import LinkBox from './LinkBox'

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 20px;
  margin-bottom: 15px;
`

const RelatedLinksBox = props => {
  return (
    <StyledDiv>
      <LinkBox title="DOCUMENTATION" links={props.docLinks} />
      <LinkBox title="RELATED LINKS" links={props.relatedLinks} />
      {/*props.relatedLinks*/}
    </StyledDiv>
  )
}

export default RelatedLinksBox
